export default __webpack_public_path__ + "static/media/rejected.9845bdc5.svg";